import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => (
    <footer className="footer">
        <div className="container">
            <nav className="footer-nav">
                <Link className="footer-nav-item active" to="/">Dhka Shop</Link>
                <Link className="footer-nav-item" to="/order">Cara Order</Link>
            </nav>
        
            <span className="footer-social">
                <a className="footer-nav-item icon" href="https://github.com/ferdhika31" title="Github Personal"><i className="devicon-github-plain vertical-middle"></i></a>
                <a className="footer-nav-item icon" href="https://twitter.com/ferdhikaaa" title="@ferdhikaaa on Twitter"><i className="devicon-twitter-plain vertical-middle"></i></a>
            </span>
        </div>
    </footer>
  )
  
  export default Footer


// WEBPACK FOOTER //
// ./src/containers/Footer.jsx